export default "__VITE_ASSET__Oqj90tgZ__"